import React from 'react';

import { observer } from 'mobx-react';
import { useStores } from 'bringg-web';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Tooltip } from '@bringg/react-components';
import { RoutesMonitoringResponse } from '@bringg/types';

import { Link } from 'bringg-web/components';

import styles from './route-row.module.scss';

interface RouteGroupRowProps {
	routeId: number;
	routeData?: RoutesMonitoringResponse;
}

const RouteRow = ({ routeId, routeData }: RouteGroupRowProps) => {
	const { plannedRoutesStore, runStore } = useStores();
	const route = routeData ? routeData : runStore.get(routeId);
	if (!route) {
		return null;
	}

	const id = route.external_id || route.id;

	let plannedRouteTitle;
	if (route.planned_route_id) {
		const plannedRoute = plannedRoutesStore.get(route.planned_route_id);
		plannedRouteTitle = `${plannedRoute?.title || ''}_${id}`;
	}

	const createTooltipRow = (value: string | number, icon: BringgFontIcons, rowId?: string | number) => {
		return (
			!!value && (
				<div data-test-id={rowId || value}>
					<BringgIcon iconName={icon} /> {value}
				</div>
			)
		);
	};

	const getRouteTooltip = () => {
		return (
			<div data-test-id={`route-${id}`}>
				{createTooltipRow(id, BringgFontIcons.Route, 'route-name')}
				{createTooltipRow(route.task_ids.length, BringgFontIcons.Checklist, 'tasks-count')}
			</div>
		);
	};

	return (
		<Link to={`/runs/${route.id}`} openInNewTab className={styles.routeName} data-test-id={`route-link`}>
			<Tooltip title={getRouteTooltip} mouseEnterDelay={0.5}>
				{plannedRouteTitle || id}
			</Tooltip>
		</Link>
	);
};

export default observer(RouteRow);
